
interface Regiao {
  title: string;
  description: string;
}

export const getRegioes = (): Regiao[] => [
  {
    title: 'ACRE',
    description: 'Avenida Brasil , Xavier Maia Nº 668 Anexo Nº 638 - Xavier Maia, Rio Branco - AC, 69903-018'
  },
  {
    title: 'RONDÔNIA',
    description: 'Rua Raimundo Cantuária, 2881 - Anexo 2901 - Roque, Porto Velho - RO, 76804-434'
  },
  {
    title: 'DISTRITO FEDERAL',
    description: 'SIA Trecho 4 Lote 1930 - Zona Industrial, Brasília - DF, 71200-043'
  },
  {
    title: 'ESPÍRITO SANTO',
    description: 'Av. Des. Mário da Silva Nunes, 558 - Jardim Limoeiro, Serra - ES, 29164-044'
  },
  {
    title: 'RIO GRANDE DO SUL',
    description: 'Av. Cruzeiro, 271 - Distrito Industrial, Cachoeirinha - RS, 94930-615'
  },
  {
    title: 'GOIÁS',
    description: 'Rua 15 Qd 15 Lt 4/7 - Polo Empresarial, Aparecida de Goiânia - GO, 74985-253'
  },
  {
    title: 'MATO GROSO',
    description: 'Av. José Estêvão Torquato da Silva, Nº 1360 - Jardim Vitória, Cuiabá - MT, 78055-731'
  },
  {
    title: 'MATO GROSSO DO SUL',
    description: 'R. Vespasiano Barbosa Martins, 212 - Vila Alba, Campo Grande - MS, 79100-020'
  },
  {
    title: 'SÃO PAULO',
    description: 'R. Armando de Campos, 221 - Terminal Intermodal de Cargas (TIC), Campinas - SP, 13069-129'
  },
  {
    title: 'MINAS GERAIS',
    description: 'R. Alcobaça, 1270 - São Francisco, Belo Horizonte - MG, 31255-210'
  },
  {
    title: 'TOCANTINS',
    description: 'Rodovia TO 050, Km 07 - Chácara Requel, Zona Rural, Palmas - TO, 77064-596'
  },
];